import { FormattedMessage } from 'react-intl';

const creationSteps = [
  { id: 'accounts.create.status.validating' },
  { id: 'accounts.create.status.syncing' },
];

export default function LoadingMessage() {
  return (
    <div className="rounded-2xl border border-slate-100 bg-slate-50 p-4 text-sm text-slate-600">
      <div aria-live="polite" className="space-y-3">
        <div className="flex items-center gap-3 text-slate-900">
          <span
            className="h-5 w-5 rounded-full border-2 border-slate-200 border-t-brand-500 animate-spin"
            aria-hidden="true"
          />
          <p className="text-sm font-semibold">
            <FormattedMessage id="accounts.create.status.processing" />
          </p>
        </div>
        <div className="space-y-1 text-sm text-slate-500">
          {creationSteps.map((step) => (
            <div key={step.id} className="flex items-center gap-2">
              <span className="h-1 w-1 rounded-full bg-slate-300" aria-hidden="true" />
              <span>
                <FormattedMessage id={step.id} />
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
